import { render } from "./teacher-lesson.vue?vue&type=template&id=1c249419&scoped=true"
import script from "./teacher-lesson.vue?vue&type=script&lang=js"
export * from "./teacher-lesson.vue?vue&type=script&lang=js"

import "./teacher-lesson.vue?vue&type=style&index=0&id=1c249419&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c249419"]])

export default __exports__